import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed, ComputedRef } from 'vue'

  // Types
  import { TravellerSummary } from '@/services/BookingService.interface'

  // Components
  import Traveller from './Traveller.vue'

  // Props
  interface Props {
    travellers: TravellerSummary[]
    departureDate?: string
    panelMode?: boolean
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TravellersList',
  props: {
    travellers: {},
    departureDate: {},
    panelMode: { type: Boolean }
  },
  setup(__props: any) {

  // Vue
  const props = __props

  // Computed

  // Orded travellers by age
  const orderedTravellers: ComputedRef<TravellerSummary[]> = computed(() => {
    return props.travellers
      .slice()
      .sort((travellerA: TravellerSummary, travellerB: TravellerSummary) => {
        return (
          new Date(travellerA.birthday).getTime() -
          new Date(travellerB.birthday).getTime()
        )
      })
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.panelMode && 'd-flex flex-column gap-3')
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedTravellers.value, (traveller, index) => {
      return (_openBlock(), _createBlock(Traveller, {
        key: `${traveller.birthday}-${index}`,
        panelMode: _ctx.panelMode,
        traveller: traveller,
        "traveller-index": index,
        "departure-date": _ctx.departureDate
      }, null, 8, ["panelMode", "traveller", "traveller-index", "departure-date"]))
    }), 128))
  ], 2))
}
}

})